import dayjs from 'dayjs';
import {
  DataModel, DataModelBuilder, SerializationContext, SerializedData,
} from '../dto/data-model.js';
import { BusinessModuleRef } from './business-module-ref.js';
import { MapUtils } from '../../utility/map-utils.js';
import { isSameData } from '../dto/data-model-utils.js';

export class VoucherForOfflineUsage extends DataModel {
  static readonly TYPE_ID: string = 'a27fd06cfbf04519bd759454e9bbb398';

  private constructor(
    public readonly voucherId: string,
    public readonly businessRef: BusinessModuleRef,
    public readonly creationDate: dayjs.Dayjs,
    public readonly creatorId: string,
  ) {
    super();
  }

  get $typeId(): string {
    return VoucherForOfflineUsage.TYPE_ID;
  }

  static create(args: {
    voucherId: string,
    businessRef: BusinessModuleRef,
    creationDate: dayjs.Dayjs,
    creatorId: string,
  }): VoucherForOfflineUsage {
    return new VoucherForOfflineUsage(
        args.voucherId,
        args.businessRef,
        args.creationDate,
        args.creatorId,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): VoucherForOfflineUsage {
    return VoucherForOfflineUsage.create({
      voucherId: MapUtils.getString(map, 'voucherId'),
      businessRef: BusinessModuleRef.mustDecode(MapUtils.getString(map, 'businessRef')),
      creationDate: context.decodeDate(MapUtils.getInteger(map, 'creationDate')),
      creatorId: MapUtils.getString(map, 'creatorId'),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      voucherId: this.voucherId,
      businessRef: this.businessRef.encode(),
      creationDate: context.encodeDate(this.creationDate),
      creatorId: this.creatorId,
    };
  }

  clone(): this {
    return VoucherForOfflineUsage.create({
      voucherId: this.voucherId,
      businessRef: this.businessRef.clone(),
      creationDate: this.creationDate,
      creatorId: this.creatorId,
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.voucherId === this.voucherId &&
      isSameData(other.businessRef, this.businessRef) &&
      other.creationDate === this.creationDate &&
      other.creatorId === this.creatorId;
  }
}

export class VoucherForOfflineUsageBuilder extends DataModelBuilder<VoucherForOfflineUsage> {
  build(context: SerializationContext, map: SerializedData): VoucherForOfflineUsage {
    return VoucherForOfflineUsage.fromMap(context, map);
  }
}
